import React, { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, ShoppingBag, Package, Users, BarChart3, Settings,
  Search, Menu, Plus, Bell, Boxes, ShieldAlert,
} from "lucide-react";
import { useAdminAuth } from "./AdminAuthContext";
import { ToastProvider } from "./ToastProvider";
import "./admin.css";

const NAV_GROUPS = [
  {
    label: "Overview",
    items: [{ to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" }],
  },
  {
    label: "Commerce",
    items: [
      { to: "/admin/orders", icon: ShoppingBag, label: "Orders", badge: "pending" },
      { to: "/admin/products", icon: Package, label: "Products" },
      { to: "/admin/inventory", icon: Boxes, label: "Inventory", badge: "low_stock" },
      { to: "/admin/customers", icon: Users, label: "Customers" },
    ],
  },
  { label: "Insights", items: [{ to: "/admin/analytics", icon: BarChart3, label: "Analytics" }] },
  {
    label: "System",
    items: [
      { to: "/admin/security", icon: ShieldAlert, label: "Security" },
      { to: "/admin/settings", icon: Settings, label: "Settings" },
    ],
  },
];

export default function AdminLayout() {
  const { admin, signOut } = useAdminAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const initials = (admin?.email || "?").slice(0, 2).toUpperCase();

  return (
    <ToastProvider>
      <div className="adm">
        <div className="adm-layout">
          {open && <div className="adm-sidebar-scrim" onClick={() => setOpen(false)} />}
          <aside className={`adm-sidebar ${open ? "open" : ""}`}>
            <Link to="/admin" className="adm-brand" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="adm-brand-mark">DC</div>
              <div>
                <div className="adm-brand-text">Damage Culture</div>
                <div className="adm-brand-sub">Admin</div>
              </div>
            </Link>
            <nav className="adm-nav">
              {NAV_GROUPS.map((g) => (
                <div key={g.label} className="adm-nav-group">
                  <div className="adm-nav-group-label">{g.label}</div>
                  {g.items.map((it) => (
                    <NavLink
                      key={it.to}
                      to={it.to}
                      end={it.end}
                      className={({ isActive }) => `adm-nav-link ${isActive ? "active" : ""}`}
                      onClick={() => setOpen(false)}
                    >
                      <it.icon size={15} />
                      <span>{it.label}</span>
                    </NavLink>
                  ))}
                </div>
              ))}
            </nav>
            <div className="adm-userblock">
              <div className="adm-avatar">{initials}</div>
              <div className="adm-userblock-meta">
                <div className="adm-userblock-name">Admin</div>
                <div className="adm-userblock-email">{admin?.email}</div>
              </div>
              <button className="adm-signout-btn" onClick={async () => { await signOut(); navigate("/admin/login"); }}>
                Sign out
              </button>
            </div>
          </aside>

          <div className="adm-content">
            <header className="adm-topbar">
              <button className="adm-icon-btn" onClick={() => setOpen(!open)} aria-label="Toggle sidebar" style={{ display: "none" }}>
                <Menu size={16} />
              </button>
              <div className="adm-search">
                <Search size={14} /> Search orders, products, customers...
                <span className="kbd">{"\u2318 K"}</span>
              </div>
              <div className="adm-topbar-spacer" />
              <button className="adm-icon-btn" aria-label="Notifications"><Bell size={15} /></button>
              <button className="adm-topbar-action" onClick={() => navigate("/admin/products?new=1")}>
                <Plus size={14} /> Add product
              </button>
              <div className="adm-avatar" title={admin?.email}>{initials}</div>
            </header>
            <main className="adm-main">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </ToastProvider>
  );
}
